import { useEffect, useRef } from 'react'

import { clearAllBodyScrollLocks } from 'body-scroll-lock'
import { colors, fontSize, size } from '@styles/theme'
import { useAuthContext } from '@contexts/authContext'
import useDialog from '@hooks/useDialog'
import styled from '@emotion/styled'

import { BackgroundImage, BottomButtonGroup } from './landing/LandingElements'
import NearbySettingsDialog from '@forms/profile_forms/MainProfileForm'
import { PiArrowRightBold, PiUserPlusBold } from 'react-icons/pi'
import ModalContainer from '@elements/ModalContainer'
import { Link, useNavigate } from 'react-router-dom'
import { Button, ButtonBase } from '@mui/material'

const WelcomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: space-between;
  position: relative;

  height: 100%;
  width: 100%;

  overflow-x: hidden;
  overflow-y: scroll;
`

const TitleArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding-top: ${size(5)};
  padding-bottom: ${size(2)};
`

const ProfileSettingsButton = styled(ButtonBase)`
  // background-color: rgba(0,0,0,0.5);
  // background-color: ${colors.statusColors.chatting('primary')};
  background: linear-gradient(139deg, #1976D2 23.12%, #1DE4D0 108.2%);
  // border: 0.5px solid rgba(255,255,255,0.1);
  // border: 0.5px solid ${colors.statusColors.chatting('primary')};
  // color: ${colors.statusColors.chatting('light')};
  color: white;
  // width: 100%;
  height: ${size(6)};
  border-radius: 100px;
  font-weight: 600;
  font-size: ${fontSize('md')};
  margin: 0 auto;
  width: 75svw;
  max-width: ${size(45)};
`

const SubscriptionOffersButton = styled(ButtonBase)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(0,0,0,0.5);
  // border: 0.5px solid rgba(255,255,255,0.1);
  border: 0.5px solid ${colors.statusColors.right_now('primary')};
  color: ${colors.statusColors.right_now('light')};
  // width: 100%;
  height: ${size(8)};
  border-radius: 100px;
  font-weight: 600;
  font-size: ${fontSize('sm')};
  margin: ${size(2)} ${size(2)};
`


const ContinueButton = styled(Button)`
  // background: linear-gradient(139deg, #1976D2 23.12%, #1DE4D0 108.2%);
  background: linear-gradient(172.5deg, #2293EE 23.12%, #751DE4 110%);
  color: white !important;
  // max-width: ${size(40)};
  flex-grow: 2;
  padding: ${size(1.5)} 0;
  margin: ${size(0.5)};
  border-radius: 100px;
  font-weight: bold;
`

const WelcomeModal = ({ isOpen }) => {
  const [isNearbySettingsOpen, openNearbySettings, closeNearbySettings] = useDialog('nearby_profile_settings_welcome', 'nearby-profile-settings-welcome-open', { params: { form_display: 'nearby-social', title: 'Add New Info' } })
  const { state: authState } = useAuthContext()
  const navigate = useNavigate()
  const firstRender = useRef(true)

  // NOTE: This is a failsafe just in case the age verification modal doesn't clear the body scroll lock
  // it sets to render correctly in safari. If the scroll lock isn't cleared, safari users can't scroll at all!
  useEffect(() => {
    clearAllBodyScrollLocks()
  }, [])

  // Navigates to the landing if attempted to access while the user is not created
  useEffect(() => {
    if (!authState?.user) navigate('/landing')
  }, [authState?.user])

  // opens settings dialog on the first render only
  useEffect(() => {
    if (isOpen && firstRender.current) {
      openNearbySettings()
      firstRender.current = false
    }
  }, [isOpen])

  return (
    <ModalContainer noHeader open={isOpen}>
      <NearbySettingsDialog
        isOpen={isNearbySettingsOpen}
        setClosed={closeNearbySettings}
      />
      <BackgroundImage src='https://mandrake-app.b-cdn.net/dev/application/display_elements/display-background-2-480w.jpeg' />
      <WelcomeContainer>
        <TitleArea>
          <span style={{ fontSize: size(4), lineHeight: size(5) }}>🎆&nbsp;🥂&nbsp;😏</span>
          <h1 style={{ fontSize: size(3), lineHeight: size(5), marginBottom: '0' }}> Welcome to Mandrake!</h1>
        </TitleArea>
        <p style={{ textAlign: 'center', fontSize: fontSize('sm'), lineHeight: size(3), margin: `${size(0)} ${size(3)} ${size(3)} ${size(3)}` }}>
          🐣 Mandrake is a new app<br />
          Consider <Link to='/subscription' style={{ color: colors.statusColors.chatting('primary') }} ><b><u>Supporter +</u></b></Link> to watch it grow
        </p>
        {/* <p style={{ textAlign: 'center', fontSize: fontSize('sm'), lineHeight: size(3), margin: `${size(3)} ${size(3)} ${size(4)} ${size(3)}` }}>
          Add pictures and stats to get started
        </p> */}
        <ProfileSettingsButton
          onClick={() => openNearbySettings()}>
          <PiUserPlusBold size={size(2.25)} />&nbsp;
          Edit Profile
        </ProfileSettingsButton>
        <div style={{ padding: size(2), marginTop: size(1.5), textAlign: 'center', backgroundColor: '#333333', width: '75svw', marginLeft: 'auto', marginRight: 'auto', borderRadius: 20 }}>
          <h3 style={{ textAlign: 'center', marginTop: 0, paddingTop: 0, fontSize: fontSize('md'), fontWeight: 500 }}>Helpful Tips</h3>
          <ol style={{ fontSize: fontSize('sm'), paddingInline: 'unset', lineHeight: 1.5, display: 'grid', gap: size(2), listStyleType: 'none' }}>
            <li>
              Use the <em style={{ color: colors.statusColors.chatting('light') }}>looking status</em> to tell people what you're looking for:<br />😎 👀 🤝 💬 💖
            </li>
            <li>
              <em style={{ color: colors.statusColors.chatting('light') }}>Make posts</em> to the nearby feed with your <em style={{ color: colors.statusColors.chatting('light') }}>social profile</em> when you're registered.
            </li>
          </ol>
        </div>
        {/* <SubscriptionOffersButton component={Link} to='/subscription'> */}
          {/* <span style={{ display: 'flex', alignItems: 'center', }}>See Supporter Features&nbsp;<PiArrowRightBold /></span>
          <div style={{ fontSize: fontSize('xs'), fontWeight: '400', marginTop: size(1.25) }}>
            <em style={{ color: colors.statusColors.romance('light') }}>$3.99/month</em>
            &nbsp;&nbsp;&nbsp;
            <em style={{ color: colors.statusColors.chatting('light') }}>$19.99/6month</em>
            &nbsp;&nbsp;&nbsp;
            <em style={{ color: colors.statusColors.browsing('light') }}>$35/year</em>
          </div> */}
        {/* </SubscriptionOffersButton> */}
        <BottomButtonGroup>
          <ContinueButton
            component={Link}
            to='/map'
            variant='contained'
            size='large'>
            Let's Go&nbsp;
            <PiArrowRightBold />
          </ContinueButton>
        </BottomButtonGroup>
      </WelcomeContainer>
    </ModalContainer>
  )
}

export default WelcomeModal
